/*
 Так как window.history не позволяет обращаться к следующим/предыдущим элементам истории
 Мы храним первое состояние нашего приложения здесь, которое по факту может находиться на N уровней ниже
*/
var isPrevRouteFirst = false;
export function updateRouteState() {
  isPrevRouteFirst = Boolean(window) && !window.history.state.uri;
}
export function isPreviousRouteFirst() {
  return isPrevRouteFirst;
}